<template>
    <div class="loading-page" :class="{ 'ac-bg-gray': ac }">
        <header-component :is-soon="false" img-left="/trocachip/img/setinha-left-preto.svg"
            img-right="/trocachip/img/access.png" class="header-component" />
        <div class="loading-page-content">
            <strong v-html="title"></strong>
            <loader-page class="loading_page_indicador" id="loading_page_indicador" :isBlue="true" />
        </div>
    </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import { mapState } from "vuex";
import LoaderPage from '../components/LoaderPage.vue';
import eSim from "../services/eSim";
import Order from "../services/order";

export default {
    name: "loading-page",
    components: {
        HeaderComponent,
        LoaderPage,
    },
    props: {
        title: { type: String, default: "Aguarde enquanto estamos concluindo sua solicitação" },
    },
    computed: {
        ...mapState({
            ac: state => state.ac,
            customer: state => state.customer,
            config: state => state.config,
            eligibilityErrorsCount: state => state.eligibilityErrorsCount,
            pinToken: state => state.pinToken,
            code: state => state.code,
            reason: state => state.reason,
            canReserve: state => state.canReserve,
            canOrder: state => state.canOrder
        })
    },
    created() {
        this.callReserveEsim();
    },
    methods: {
        callReserveEsim() {
            console.log("RESERVE " + this.canReserve + " ORDER " + this.canOrder)
            if (!this.canReserve && this.config.enable_reserve_order_one_time_use) {
                this.redirectToErrorPage();
                return;
            }
            eSim.reservaEsim().then((response) => {
                if (!response.data) this.redirectToErrorPage();

                this.$store.dispatch("urlEsim", response.data.url);
                this.$store.dispatch("iccidEsim", response.data.simCard.iccid);
                this.$store.dispatch("disallowReserve");
                this.$store.dispatch("allowOrder");
                this.sendCustomDimension('ICCID_TC', response.data.simCard.iccid);
                this.callCreateOrder(response.data.simCard.iccid, response.data.url);
            }).catch(() => {
                this.redirectToErrorPage();
            })
        },
        async sendCustomDimension(dimension, value) {
            // Convert value to string if it's not already
            const strValue = String(value);

            // Replace spaces, asterisks, and parentheses
            const sanitizedValue = strValue
                .replace(/\s/g, '_')    // Replace spaces with underscores
                .replace(/\*/g, '_')     // Remove asterisks
                .replace(/[()]/g, '_');  // Remove parentheses - no need to escape inside []
            console.log("Sending " + dimension + ": " + sanitizedValue);
            const command = `decibelInsight("sendCustomDimension", "${dimension}", "${sanitizedValue}");`;
            console.log(command)
            window.eval(command);
        },
        callCreateOrder(iccid, urlEsim) {
            console.log("RESERVE " + this.canReserve + " ORDER " + this.canOrder)
            console.log("Sending ICCID_TC: " + iccid);
            this.sendCustomDimension('ICCID_TC', iccid);
            if (!this.canOrder && this.config.enable_reserve_order_one_time_use) {
                this.redirectToErrorPage();
                return;
            }

            Order.getOrder(this.code, this.pinToken, iccid, this.reason, urlEsim, this.getAcceptedBiometry()).then(response => {
                if (response.data.internalCode == "1") {
                    this.$store.dispatch('protocol', response.data.protocol)
                    this.$router.push('/ativado-esim')
                } else {
                    this.redirectToErrorPage();
                }
            }).catch(() => {
                this.redirectToErrorPage();
            })
        },
        redirectToErrorPage() {
            this.$router.push({ name: "default-error" })
        },
        returnHome() {
            this.$router.push({ name: "welcome" })
        },
        getAcceptedBiometry() {
            if (this.config.parameterBiometryAccepted[this.customer.segment] && this.config.parameterBiometryAccepted[this.customer.segment].includes(this.customer.login.substring(0, 2))) {
                return true;
            }
            return false;
        }
    }
}
</script>

<style lang="scss" scoped>
.loading-page {
    width: 100vw;
    margin-top: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loading_page_indicador {
    margin-top: 50px;
    width: 40px;
    height: 40px;
}

.loading-page-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'timsans_regular';
    text-align: center;
}

.loading-page-content strong {
    font-size: 24px;
    font-weight: 300;
    margin-top: 50px;
    line-height: 35px;
}

.loading-page-content span {
    margin-top: 27px;
    opacity: 0.6;
    font-size: 16px;
    color: #000000;
    width: 75%;
}
</style>
